import { http , lHttp } from '@utils/interceptor'
import { getSelectedCityId } from '@utils/index'
import {  toArray } from 'lodash'
import { Toast } from 'vant'

const api = {
    // babyListApi: '//user.haiziwang.com/user/GetBabyInfo',
    channelDataApi: '//soperationapi.haiziwang.com/soperation-api/citySite/queryChannel.do',
    grayscale: '//cms.cekid.com/publish/999/h5-category-grayscale.json',
}

export interface ChannelData{
    channelName: string
    categoryIds: string
    ads: any
    item: any[]
}

export async function getChannelData(channelId: string , cityId: string|number) : Promise<ChannelData>{
    const result = await lHttp.get(`${api.channelDataApi}`, { params: { cityId , channelId } })
    const { data, code, msg } = result
    if (+code === 1 && data ) {
        return data
    } else {
        Toast(msg)
        return Promise.reject(msg)
    }
}

export async function getGrayscale() {
    const response: ResponseCode = await lHttp.get(api.grayscale)
    if (response && response.code == 0 && response.data) {
      return toArray(response.data.itemTypeList)
    } else {
      return null
    }
  }